import React from "react";
import { useTranslateKey } from "../hooks/useTranslate";
import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ReactComponent as NoticeIcon } from "../assets/icons/notice-icon.svg";
import { useSystemOutageFlag } from "../hooks/useSystemOutageFlag";

const SystemOutageBanner = () => {
  const theme = useTheme();
  const viewportIsSmall = useMediaQuery(theme.breakpoints.up("sm"));
  const enabled = useSystemOutageFlag();
  const systemOutageLabel = useTranslateKey("system_outage");
  const genericOpsMessage = useTranslateKey("generic_ops_message");

  if (!enabled) return null;

  return (
    <Stack
      data-test-id="system-outage-banner"
      className="notice-stack"
      flexDirection="row"
      alignItems="center"
      gap={1}
      p={1.5}
      mr={!viewportIsSmall && 2}
      ml={!viewportIsSmall && 2}
      variant="error"
    >
      <Stack>
        <NoticeIcon className="notice-icon" width={20} height={20} />
      </Stack>
      <Typography
        variant="body1"
        sx={{
          fontSize: "calc(12px * var(--unicity-font-scale, 1))",
          fontWeight: "400",
        }}
      >
        <strong>{systemOutageLabel}:</strong> {genericOpsMessage}
      </Typography>
    </Stack>
  );
};

export { SystemOutageBanner };
